module.exports = __webpack_public_path__ + "static/media/teamCartoon.5c556640.png";